<template>
  <v-app style="background-color: #f8f9fb">
    <v-container>
      <v-col cols="12">
        <v-card elevation="0" class="px-5 py-3">
          <v-card-title class="px-0 pt-0">Consultar Cartão TEM</v-card-title>
          <v-row align="end">
            <v-col cols="12" sm="8" md="5">
              <span>CPF ou Contrato</span>
              <v-text-field
                v-model="pesquisa"
                label="Digite o CPF ou Contrato"
                dense
                solo-inverted
                :disabled="loadConsulta"
                @keyup.enter="consultaTem"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <span>&nbsp;</span>
              <v-btn
                color="#4682B4"
                block
                height="40"
                style="font-size: 14px; font-weight: bold"
                :loading="loadConsulta"
                :disabled="!pesquisa"
                @click="consultaTem"
              >
                Consultar
                <v-icon right dark>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-container>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-alert v-if="mensagem" type="error" dense class="mb-4">
        {{ mensagem }}
      </v-alert>

      <v-card v-if="cartao" elevation="0" class="pa-5">
        <v-card-title class="px-0 pt-0">Informações Encontradas</v-card-title>
        <v-card-text class="px-0">
          <div><strong>Nome:</strong> {{ cartao.nome }}</div>
          <div><strong>CPF:</strong> {{ cartao.cpf }}</div>
          <div><strong>Contrato:</strong> {{ cartao.contrato }}</div>
          <div><strong>Status:</strong> {{ cartao.status }}</div>
          <div><strong>Cartão:</strong> {{ cartao.cartao }}</div>
        </v-card-text>

        <v-card-actions class="px-0">
          <v-btn
            v-if="cartao.status === 'SUSPENSO'"
            :loading="loadConsulta"
            color="primary"
            @click="ativarCartao"
          >
            Ativar Cartão
          </v-btn>

          <v-btn
            v-if="cartao.status === 'ATIVO'"
            :loading="loadConsulta"
            color="orange"
            @click="suspenderCartao"
          >
            Suspender Cartão
          </v-btn>

          <v-btn
            v-if="cartao.status === 'ATIVO'"
            :loading="loadConsulta"
            color="red"
            @click="cancelarCartao"
          >
            Cancelar Cartão
          </v-btn>

          <v-btn
            v-if="cartao.status === 'PENDENTE'"
            :loading="loadConsulta"
            color="primary"
            @click="adesaoCartao"
          >
            Confirmar Adesão
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import TemSaude from "@/services/temsaude";

export default {
  name: "TemSaude",
  data: () => ({
    pesquisa: "",
    cartao: null,
    mensagem: "",
    loadConsulta: false,
  }),
  methods: {
    cartaoLimpo() {
      return (this.cartao?.cartao || "").replace(/ /g, "");
    },
    async consultaTem() {
      if (!this.pesquisa) return;
      this.loadConsulta = true;
      this.mensagem = "";
      try {
        const response = await TemSaude.consultaLoja(this.pesquisa);
        if (response.data) {
          this.cartao = response.data;
        } else {
          this.cartao = null;
          this.mensagem = "Nenhuma informação encontrada para a consulta.";
        }
      } catch (e) {
        this.cartao = null;
        this.mensagem =
          e?.response?.data?.mensagem ||
          "Erro ao realizar a consulta. Tente novamente.";
      } finally {
        this.loadConsulta = false;
      }
    },
    async ativarCartao() {
      this.loadConsulta = true;
      this.mensagem = "";
      try {
        await TemSaude.ativarCartao(this.cartao.cpf, this.cartaoLimpo());
      } catch (e) {
        this.mensagem = "Erro ao ativar o cartão.";
        this.loadConsulta = false;
      } finally {
        await this.consultaTem();
      }
    },
    async suspenderCartao() {
      if (!confirm("Você tem certeza que deseja suspender o cartão?")) return;
      this.loadConsulta = true;
      this.mensagem = "";
      try {
        await TemSaude.suspenderCartao(this.cartao.cpf, this.cartaoLimpo());
      } catch (e) {
        this.mensagem = "Erro ao suspender o cartão.";
        this.loadConsulta = false;
      } finally {
        await this.consultaTem();
      }
    },
    async cancelarCartao() {
      if (!confirm("Você tem certeza que deseja cancelar o cartão?")) return;
      this.loadConsulta = true;
      this.mensagem = "";
      try {
        await TemSaude.cancelarCartao(this.cartao.cpf, this.cartaoLimpo());
      } catch (e) {
        this.mensagem = "Erro ao cancelar o cartão.";
        this.loadConsulta = false;
      } finally {
        await this.consultaTem();
      }
    },
    async adesaoCartao() {
      this.loadConsulta = true;
      this.mensagem = "";
      try {
        const response = await TemSaude.adesaoCartao(
          this.cartao.cpf,
          this.cartaoLimpo()
        );
        if (
          response.data?.statusCartao &&
          String(response.data.statusCartao).includes("Client error")
        ) {
          alert(response.data.statusCartao);
        }
      } catch (e) {
        this.mensagem = "Erro ao fazer adesão do cartão.";
        this.loadConsulta = false;
      } finally {
        await this.consultaTem();
      }
    },
  },
};
</script>
